<template>
  <StackLayout :class="classes">
    <!-- no component here because "image" element already exists in web -->
    <div v-if="isWeb" :style="style" @tap="$emit('tap', $event)" @click="$emit('click', $event)" @touch="$emit('touch', $event)"></div>
    <Image v-else :src="src" :stretch="stretch" :borderRadius="radius" :height="height" @tap="$emit('tap', $event)" @click="$emit('click', $event)" @touch="$emit('touch', $event)" />
  </StackLayout>
</template>
<script>

import env from '@/helpers/env'

export default {
  props: {
    src: {
      type: String
    },
    stretch: {
      type: String
    },
    borderRadius: {
      type: [Number, String],
      default: 0
    },
    round: {
      type: Boolean
    },
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String]
    },
    link: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      let classes = [
        'image'
      ]

      if (this.link) {
        classes.push('link')
      }

      return classes.join(' ')
    },
    isWeb () {
      return env.isWeb
    },
    radius () {
      return this.round ? '50%' : this.borderRadius
    },
    style () {
      let rules = [
        'background-image: url(' + (this.src.slice(0, 2) === '~/' ? '.' + this.src.slice(1) : this.src) + ');',
        'border-radius: ' + this.radius + ';'
      ]

      if (typeof this.width !== 'undefined') {
        rules.push('width: ' + this.width + (this.width.slice(-1) === '%' ? '' : 'px') + ';')
      }

      if (typeof this.height !== 'undefined') {
        rules.push('height: ' + this.height + (this.height.slice(-1) === '%' ? '' : 'px') + ';')
      }

      if (this.stretch === 'aspectFill' || this.stretch === 'fill') {
        rules.push('background-size: cover;')
      }

      return rules.join(' ')
    }
  }
}

</script>

<style lang="scss" scoped>

html {
  .image div {
    overflow: hidden;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    image-rendering: auto;
  }

  .image.link div {
    cursor: pointer;
  }
}

</style>